export default __webpack_public_path__ + "static/media/plans_icon.17a75a2a.svg";